export default "__VITE_ASSET__DTtyT$Qj__"